
export const normalizeProductShelfData = ({ slotData, componentData, mediaCollectionIndex = 0 }) => {
  if (slotData?.slot) {
    const { slot } = slotData;
    const mediaCollection = slot.mediaCollections?.[mediaCollectionIndex];
    const media = mediaCollection?.media?.[0];

    let customProps = {};
    if (media?.customProps) {
      try {
        customProps = typeof media.customProps === 'string' ? JSON.parse(media.customProps) : media.customProps;
      } catch (e) {
        console.error('Error parsing customProps:', e);
      }
    }
    return {
      source: 'slot',
      id: mediaCollection.id,
      componentName: 'ProductShelf',
      title: mediaCollection.title,
      sortBy: customProps.sortBy || null,
      sortOrderOptions: customProps.sortOrderOptions || null,
      theme: mediaCollection?.theme || null,
      publishDate: customProps.publishDate || null,
      productShelfData: {
        navParam: customProps.productShelfData?.navParam || null,
        skus: customProps.productShelfData?.skus || null
      }
    };
  }

  if (componentData?.component) {
    const { component } = componentData;
    return {
      source: 'component',
      id: component.id,
      componentName: component.componentName,
      title: component.title,
      sortBy: component.sortBy,
      sortOrderOptions: component.sortOrderOptions,
      theme: component.theme,
      publishDate: component.publishDate || null,
      productShelfData: {
        navParam: component.productShelfData?.navParam || null,
        skus: component.productShelfData?.skus || null
      }
    };
  }

  return null;
};
